import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Home from '@/pages/Home';
import Designers from '@/pages/Designers';
import DesignerDetail from '@/pages/DesignerDetail';
import UserDashboard from '@/pages/UserDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import Auth from '@/pages/Auth';
import PaymentSuccess from '@/pages/PaymentSuccess';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import SupportTicket from '@/pages/SupportTicket';
import TermsAndConditions from '@/pages/TermsAndConditions';
import { Toaster } from '@/components/ui/sonner';
import { getStoredUser, subscribeToAuthSession } from '@/lib/authSession';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setUser(getStoredUser());
    setLoading(false);

    return subscribeToAuthSession((nextUser) => {
      setUser(nextUser);
    });
  }, []);

  const ProtectedRoute = ({ children, adminOnly = false }) => {
    const hasToken = Boolean(localStorage.getItem('token'));
    if (loading) return <div>Loading...</div>;
    if (!user || !hasToken) return <Navigate to="/auth" />;
    if (adminOnly && user.role !== 'admin') return <Navigate to="/" />;
    return children;
  };

  if (loading) {
    return <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-[#d4a574] text-xl">Loading...</div>
    </div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/designers" element={<Designers user={user} />} />
          <Route path="/designers/:id" element={<DesignerDetail user={user} />} />
          <Route path="/products" element={<Products user={user} />} />
          <Route path="/products/:id" element={<ProductDetail user={user} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy user={user} />} />
          <Route path="/support" element={<SupportTicket user={user} />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions user={user} />} />
          <Route path="/auth" element={<Auth setUser={setUser} />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <UserDashboard user={user} setUser={setUser} />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminDashboard user={user} />
            </ProtectedRoute>
          } />
          <Route path="/payment-success" element={
            <ProtectedRoute>
              <PaymentSuccess user={user} />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
